import { RootState } from '~/store';

export const catalogBookLayoutSelector = (state: RootState) => state.catalogBookLayout;
